/**
 * Top header — shows the current admin's username + role pills + logout.
 */
import { Dropdown, Layout, Tag } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useAuthStore } from '../store/auth';
import { useTabsStore } from '../store/tabs';
import { useNavigate } from 'react-router-dom';

const { Header: AntHeader } = Layout;

export function Header() {
  const profile = useAuthStore((s) => s.profile);
  const clear = useAuthStore((s) => s.clear);
  const resetTabs = useTabsStore((s) => s.reset);
  const navigate = useNavigate();

  function handleLogout() {
    clear();
    resetTabs();
    navigate('/login', { replace: true });
  }

  return (
    <AntHeader
      style={{
        background: '#fff',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #e5e7eb',
        height: 48,
        lineHeight: '48px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 600 }}>
        <img src="/orb.jpeg" alt="" width={28} height={28} style={{ borderRadius: 6, objectFit: 'cover' }} />
        ORB 运营控制台
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {profile?.roles.map((r) => (
          <Tag key={r.id} color={r.preset ? 'purple' : 'blue'}>
            {r.name}
          </Tag>
        ))}
        <Dropdown
          menu={{
            items: [
              {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: '退出登录',
                onClick: handleLogout,
              },
            ],
          }}
        >
          <span style={{ cursor: 'pointer' }}>
            <UserOutlined /> {profile?.username}
          </span>
        </Dropdown>
      </div>
    </AntHeader>
  );
}
